var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"select-list"},_vm._l((_vm.list),function(paxItem,paxType){return _c('paxes-selector-item',{key:paxType,staticClass:"pax-selector-item",attrs:{"value":_vm.paxes[paxType],"pax-type":paxType,"min":paxItem.val[0],"max":_vm.maxTotalPax - _vm.totalPaxSelected
        ? Math.min(paxItem.val[1], _vm.maxTotalPax)
        : _vm.paxes[paxType]},on:{"input":val => _vm.onChangePax(paxType, val)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }